<template>
  <v-container>
    <v-row>
      <v-col>
        <TabComponent
          :tabs="tabs"
          :nodeId="nodeId"
          name="variant" />
      </v-col>
    </v-row>
  </v-container>
</template>

<script setup>
import { ref } from "vue";
import { useTranslation } from "i18next-vue";

import BasicData from "./FormParts/BasicData.vue";
import CalculationVariant from "./FormParts/CalculationVariant.vue";
import MaterialTab from "./ViewParts/MaterialTab.vue";
import ProductionCostsTab from "./ViewParts/ProductionCostsTab.vue";
import ManufacturingTab from "./ViewParts/ManufacturingTab.vue";
import CostBreakdownTab from "@/views/Calculations/shared/CostBreakdownTab.vue";
import SurchargeCashSalePrice from "./FormParts/SurchargeCashSalePrice.vue";
import NetSalesPrice from "./FormParts/NetSalesPrice.vue";

import TabComponent from "@/components/Elements/TabComponent.vue";

const { t } = useTranslation();
const tab = ref("basicData");

defineProps({
  nodeId: {
    type: String,
    required: true
  }
});

const tabs = [
  {
    value: "basicData",
    icon: "mdi-pencil",
    component: BasicData
  },
  {
    value: "calculationVariant",
    icon: "mdi-pencil",
    component: CalculationVariant
  },
  {
    value: "material",
    icon: "mdi-eye",
    component: MaterialTab
  },
  {
    value: "productionCosts",
    icon: "mdi-eye",
    component: ProductionCostsTab
  },
  {
    value: "manufacturing",
    icon: "mdi-eye",
    component: ManufacturingTab
  },
  {
    value: "surchargeCashSalePrice",
    icon: "mdi-pencil",
    component: SurchargeCashSalePrice
  },
  {
    value: "netSalesPrice",
    icon: "mdi-pencil",
    component: NetSalesPrice
  },
  {
    value: "costBreakdown",
    icon: "mdi-eye",
    component: CostBreakdownTab,
    containerStyle: "overflow-x: auto;"
  }
];
</script>

<style>
.smaller-tabs span.v-btn__prepend {
  margin-inline: 0 !important;
}

.smaller-tabs .v-tab {
  padding: 0 0.3rem !important;
}
</style>
